import { TicketDetailsEffects } from 'src/app/root-store/ticket-store/effects/ticket-details.effects';
import { TicketEmployeeSearchEffects } from 'src/app/root-store/ticket-store/effects/ticket-employee-search.effects';
import { TicketHistoryEffects } from 'src/app/root-store/ticket-store/effects/ticket-history.effects';
import { TicketTasksEffects } from 'src/app/root-store/ticket-store/effects/ticket-tasks.effects';
import { TicketAttachmentsEffect } from 'src/app/root-store/ticket-store/effects/ticket-attachments.effects';
import { TicketGridEffects } from 'src/app/root-store/ticket-store/effects/ticket-grid.effects';
import { TicketSettingsEffects } from 'src/app/root-store/ticket-store/effects/ticket-settings.effects';

export const ticketEffects = [
    TicketDetailsEffects,
    TicketHistoryEffects,
    TicketTasksEffects,
    TicketAttachmentsEffect,
    TicketEmployeeSearchEffects,
    TicketGridEffects,
    TicketSettingsEffects
];
